import { use } from 'react'
import { Link } from 'react-router'

type Props = {
  visible: boolean
  deliveryRange: Promise<string>
}

export const BottomBar: React.FC<Props> = ({ visible, deliveryRange }) => {
  const range = use(deliveryRange)
  const style = {
    background: 'rgba(255,255,255,0.97)',
    borderTop: '1px solid rgba(217,217,217,0.4)',
    transform: visible ? 'translateY(0)' : 'translateY(100%)',
    transition: 'transform 300ms ease',
  }

  return (
    <div className="fixed left-0 right-0 bottom-0 z-50" style={style}>
      <div className="px-5 py-3 flex items-center justify-between gap-4 max-w-5xl mx-auto">
        <p className="text-[13px] text-main leading-tight">{range ? `初回のお届け日：${range}` : ''}</p>
        <Link
          reloadDocument
          to="/subscription/branch/new"
          className="shrink-0 px-10 py-4 bg-accent text-white text-[15px] rounded-full transition-colors"
        >
          定期便を始める
        </Link>
      </div>
    </div>
  )
}
